import React, { useEffect, useState } from "react";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import Card from "../../share/cards/Card";
import CoustomTable from "../../share/Table/CoustomTable";
import { Modal } from "../../share/modal/Modal";
import ModalIdea from "../StudentCourse/ModalIdea";
import { Bar, Chart } from "react-chartjs-2";
import { defaults } from "chart.js";
import RechargeModal from "../dashboard/RechargeModal";
import WithdrawModal from "../dashboard/WithdrawModal";
import InoviceModal from "../dashboard/InoviceModal";
import ShebaModal from "../dashboard/ShebaModal";
import ShebaConfirmModal from "../dashboard/ShebaConfirmModal";
import WithdrawPriceModal from "../dashboard/WithdrawPriceModal";
import RechargeConfirmModal from "../dashboard/RechargeConfirmModal";
import useFetch from "../../../Hooks/useFetch";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import MainPagination from "../../share/Pageination/MainPagination";

function StudentFinance() {
    const [barData, setBarData] = useState(1);
    const [courseId, setCourseId] = useState();
    const [modalData, setModalData] = useState();
    const [modalbtn, setModalbtn] = useState(false);
    const [withdrawModalBtn, setWithdrawModalBtn] = useState(false);
    const [withdrawModalStep, setWithdrawModalStep] = useState(0);
    const [rechargeModalBtn, setRechargeModalBtn] = useState(false);
    const [rechargeModalStep, setRechargeModalStep] = useState(0);
    const [inoviceModalBtn, setInoviceModalBtn] = useState(false);
    const [paymentModalBtn, setPaymentModalBtn] = useState(false);
    const [transactionsPage, setTransactionsPage] = useState(0);
    const [coloumn, setColoumn] = useState(3);
    const transactionsTableStart = transactionsPage * coloumn;
    const transactionsTableEnd = transactionsPage * coloumn + coloumn;
    const [courses, setCourses] = useState();

    const [pagination, setPagination] = useState({
        current: 1,
    });

    useEffect(() => {
        draftCourse.reFetch();
    }, [pagination]);

    const draftCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_draft_bootcamp",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });

    const showModal = () => {
        setModalbtn(true);
    };
    const showWithdrawModal = () => {
        setWithdrawModalBtn(true);
    };
    const showRechargeModal = () => {
        setRechargeModalBtn(true);
    };
    const showInoviceModal = (id) => {
        setInoviceModalBtn(true);
        setCourseId(id);
    };

    useEffect(() => {
        courses?.results.map(
            (course) => course.id == courseId && setModalData(course)
        );
    }, [courseId]);

    const showPaymentModal = () => {
        setPaymentModalBtn(true);
    };

    return (
        <div className="SupportTicket">
            <h3 className="text-[1.6rem] font-bold mb-4">
                اطلاعات کلی کیف پول
            </h3>
            <Card className="flex flex-row px-10 py-11 items-center justify-between">
                <div className="flex flex-col">
                    <div className="flex flex-row gap-32">
                        <span className="text-purple text-[1.6rem] font-bold mb-16">
                            موجودی کیف پول
                        </span>
                        <span className="text-purple text-[1.6rem] font-bold">
                            1,500,000 تومان
                        </span>
                    </div>
                </div>
                <div className="self-start">
                    <div className="flex flex-row">
                        <BtnPrimary
                            onClick={showRechargeModal}
                            text="شارژ کیف پول"
                            className=" py-4 px-6 ml-4"
                        />
                        <BtnAlternative
                            onClick={showWithdrawModal}
                            text="تسویه حساب"
                            className=" py-4 px-6"
                        />
                    </div>
                </div>
            </Card>

            <h4 className="text-[1.6rem] font-bold mt-16">تراکنش‌ها</h4>
            <CoustomTable
                list={list}
                showModal={showModal}
                header={header}
                lightbtn={true}
                btn={true}
                sort={false}
                priority={false}
                num={2}
                transactionsPage={transactionsPage}
                setTransactionsPage={setTransactionsPage}
                transactionsTableStart={transactionsTableStart}
                transactionsTableEnd={transactionsTableEnd}
            />
            <Modal show={modalbtn}>
                <ModalIdea close={setModalbtn} />
            </Modal>

            <Modal show={withdrawModalBtn}>
                {withdrawModalStep === 0 && (
                    <ShebaModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 1 && (
                    <ShebaConfirmModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 2 && (
                    <WithdrawPriceModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 3 && (
                    <WithdrawModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
            </Modal>

            <Modal show={rechargeModalBtn}>
                {rechargeModalStep === 0 && (
                    <RechargeModal
                        close={setRechargeModalBtn}
                        step={rechargeModalStep}
                        setStep={setRechargeModalStep}
                    />
                )}
                {rechargeModalStep === 1 && (
                    <RechargeConfirmModal
                        close={setRechargeModalBtn}
                        step={rechargeModalStep}
                        setStep={setRechargeModalStep}
                    />
                )}
            </Modal>

            <Modal show={inoviceModalBtn}>
                <InoviceModal
                    close={setInoviceModalBtn}
                    // info={courses}
                    data={modalData}
                />
            </Modal>

            <Modal show={paymentModalBtn}>
                <InoviceModal close={setPaymentModalBtn} />
            </Modal>
        </div>
    );
}

export default StudentFinance;

const list = [
    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "حق اشتراک ماهانه سرویس نقره‌ای اسکای‌روم",
        title: "رمینا",
        price: "1,000,000",
    },

    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "واریز",
        date: "ثبت نام بوت کمپ طراحی تبلیغات دیجیتالی برای سازمان های دولتی",
        title: "رمینا",
        price: "2,500,000",
    },

    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "تبلیغات پیامکی",
        title: "رمینا",
        price: "20,000",
    },
    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "تبلیغات پیامکی",
        title: "رمینا",
        price: "20,000",
    },
];

const header = [
    { title: "نوع تراکنش" },
    { title: "عنوان" },
    { title: "تاریخ" },
    { title: "مبلغ" },
];
